import { render, staticRenderFns } from "./CategoriaEdit.vue?vue&type=template&id=15859149&scoped=true&"
import script from "./CategoriaEdit.vue?vue&type=script&lang=js&"
export * from "./CategoriaEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15859149",
  null
  
)

export default component.exports